"use client";

import { c as _c } from "react/compiler-runtime";
import { useState } from "react";
import { MenuDesktopItem } from "./MenuDesktopItem";
import type { HeaderData } from "../types";
import { cn } from "@local/utils/src/cn";
import { getT } from "@local/i18n/src/t";
import { getLanguageForMarket } from "@local/i18n/src/languages";
import { a11y } from "@local/i18n/src/catalogs/a11y";
interface Props {
  data: HeaderData | null;
  market: string;
  className?: string;
}
export const HeaderMenuDesktop = t0 => {
  const $ = _c(14);
  const {
    data,
    market,
    className
  } = t0;
  const [activeIndex, setActiveIndex] = useState(null);
  let t1;
  if ($[0] !== market) {
    const t = getT(getLanguageForMarket(market), {
      a11y
    });
    t1 = t("a11y.mainNavigation");
    $[0] = market;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== className) {
    t2 = cn("ml-4 hidden h-full flex-row items-center gap-8 align-middle text-sm xl:visible xl:flex", className);
    $[2] = className;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== activeIndex || $[5] !== data?.navigationMain || $[6] !== market) {
    t3 = data?.navigationMain?.map((item, i) => <MenuDesktopItem key={`menu-item-desktop-${item.id}-${i}`} item={item} id={`menu-item-desktop-client-${i}`} market={market} open={activeIndex === i} onOpen={() => setActiveIndex(i)} onClose={() => setActiveIndex(prev => prev === i ? null : prev)} />);
    $[4] = activeIndex;
    $[5] = data?.navigationMain;
    $[6] = market;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t3) {
    t4 = <ul className="contents list-none">{t3}</ul>;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== t1 || $[11] !== t2 || $[12] !== t4) {
    t5 = <nav aria-label={t1} className={t2}>{t4}</nav>;
    $[10] = t1;
    $[11] = t2;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  return t5;
};